import { render, staticRenderFns } from "./CourseExamQuestionForm.vue?vue&type=template&id=69d8a3a3&"
import script from "./CourseExamQuestionForm.vue?vue&type=script&lang=ts&"
export * from "./CourseExamQuestionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports